import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export function AuthRedirect(): JSX.Element {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();

  useEffect(() => {
    if (initialized) {
      if (keycloak?.authenticated) {
        navigate("/app/dashboard", {
          replace: true,
          state: { from: window.location.pathname },
        });
      }
    }
  }, [initialized, keycloak?.authenticated, navigate]);

  return !keycloak?.authenticated ? <Outlet /> : null;
}
